module.exports = __webpack_public_path__ + "static/media/machine2.223fadb1.png";